import React, { Component } from 'react';
import './popupbox.css';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';
//import InputMask from 'react-input-mask';

// COMPONENTS
import TextBox from '../TextBox/textbox';
import Button from '../Button/button';
import Label from '../Label/label';


class PopupBox extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /*
        --config={}
          // 
        --updateValue  //callbackMethod
      */
        this.state = {
          initialObject:this.props.loadedObject,
          actualObject:this.props.loadedObject
        };

  }


  // INNER METHOD
  onClickCancel = () =>{
    var config = this.props.config;
    if(config.action === "Add"){
      config.object = null;
    }else{
      config.object = this.state.initialObject;
    }
    
    this.props.onClosePopup(config);
  }
  onClickValid = () =>{
    var config = this.props.config;
    config.object = this.state.actualObject;
    if(config.action === "Add"){
      // CHECK RESERVED VALUE
      if(config.columns.filter(item=>item.unique).length>0){
        config.columns.filter(item=>item.unique).forEach(column => {
          if(column.reservedValue.includes(config.object[column.name])){
            alert("the value : "+config.object[column.name]+ " should be unique and is already in use for column :"+column.name);
          }else{
            this.props.onClosePopup(config);
          }
        });
      }else{
        this.props.onClosePopup(config);
      }
    }else{
      this.props.onClosePopup(config);
    }


   
  }

  onUpdateValue = (columnName,lang,e) =>{
    var object = {...this.state.actualObject};
    console.log("update",object,columnName,lang,e);
    if(e !==undefined){
      object[columnName][lang] = e;
    }else{
      object[columnName] = lang;
    }
    this.setState({actualObject:object});
  }

  // BUILDING METHOD
  // componentWillMount = () =>{
  //   this.setState({actualObject:{...this.props.loadedObject},initialObject:this.props.loadedObject});
  // }

  buildFormContent = (object) =>{
    var content = null;
    var columns = this.props.config.columns;
    var formLines= null;
    var config = this.props.config;
    console.log("popup boject",object);

    formLines = columns.map((column,i)=>{
      if(column.type === "Multi"){
        var multi = null;
        multi = column.choices.map((lang)=>{
          console.log("PopupBox",i);
          return(
            <div className="formLine" key={i+"-"+lang}>
            <Label  
              config={
                {
                  color:"#bbb",
                  text:column.displayName + " - "+ lang, 
                  additionalClass:"",
                  textAlign:"right"
                }
              }
            /> 
            <TextBox 
              config={
                {
                  mask:null, 
                  color:"#999",
                  readOnly:false, 
                  maxLength:0, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,column.name,lang)}
              value = {object[column.name][lang]}
            />
          </div>
          )
        });
        return (
          <div className="langWrapper" key={i}>{multi}</div>
        )

      }else{
        return (
          <div className="formLine" key={i}>
            <Label  
              config={
                {
                  color:"#bbb",
                  text:column.displayName, 
                  additionalClass:"",
                  textAlign:"right"
                }
              }
            /> 
            <TextBox 
              config={
                {
                  mask:column.mask !== undefined ? column.mask : null, 
                  color:"#999",
                  readOnly:column.state === "ReadOnly" && config.action !== "Add"?true:false, 
                  maxLength:column.limit!== undefined ? column.limit : null, 
                  textAlign:"left"
                }
              }
              updateValue={this.onUpdateValue.bind(this,column.name)}
              value = {object[column.name]}
            />
          </div>
          )
      }
      
    });

    content = <div className="popupContainer">
        <div className="popupHeader">
          <span>Object Form</span>
          <Button //Cancel
            preventMultipleClick={0} 
            config={
              {
                isEnabled:true,
                icon:"times",
                text:"",
                color:"#fff",
                textAlign:"center",
                bgcolor:"red"
              }
            } 
            OnClickElement={this.onClickCancel.bind(this)}
          />
        </div>
        <div className="popupBody">
          {formLines}
        </div>
        <div className="popupFooter">
          <Button 
            preventMultipleClick={0} 
            config={
              {
                isEnabled:true,
                icon:"check",
                text:"save change",
                color:null,
                textAlign:"center",
                bgcolor:null
              }
            } 
            OnClickElement={this.onClickValid.bind(this)}/>
        </div>
      </div>
    return content;
  }

  // ---------------------RENDER --------------------- 
  render() {
    

    return (
          <div className={"popup-wrapper show-"+this.props.show} >
              {this.buildFormContent(this.state.actualObject)}
          </div>
    );
  }
}
  
  const mapStateToProps = (state) => {    
    return {  
      loadedObject:state.apiReducer.loadedObject,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(PopupBox);
  